module.exports = __webpack_public_path__ + "img/msp-logo.6e54c882.jpg";